// Logged-in app page: Music library (routes/Music.tsx). Keep keys in sync with en/appMusic.ts.
// EXACT current Polish, verbatim. Filenames/durations and API/status field names live in
// the component — never translated. Runda 32-R5: wiersz utworu w anatomii A (nazwa, jedna
// linia danych, JEDNA akcja, „⋯”), stan mówi o TEKŚCIE, płatne akcje niosą koszt na sobie.
export const appMusic = {
  head: {
    title: 'Muzyka',
  },
  // Wgrywanie = wiersz listy o tej samej wysokości co każdy inny (`R5-05`): procent
  // i pasek w linii danych, „Przerwij” w miejscu „Użyj”. Nieudane wgrywanie też jest
  // wierszem (`R5-06`): pigułka, kod, „Ponów”, „×” zdejmuje wiersz.
  //
  // WGRANIE JEST DARMOWE (decyzja właściciela 21.09), więc żadna z tych etykiet nie
  // nosi kwoty, a okno „Wgrać {k} utwory?” (`R5-11`) — pytające raz o koszt całej
  // partii — zniknęło razem ze swoimi kluczami.
  upload: {
    progressLabel: 'Postęp wgrywania',
    abort: 'Przerwij',
    failedPill: 'nie wgrano',
    // Plik czeka na swoją kolej w przebiegu kilku plików (`R5-05`).
    queued: 'w kolejce',
    retry: 'Spróbuj ponownie',
    dismiss: 'Usuń z listy',
  },
  trim: {
    title: 'Wybierz fragment do wgrania',
    // Sufit długości fragmentu jako etykieta przy odczycie „Długość”.
    maxLen: 'maks. {max} s',
    preparing: 'Przygotowuję falę lokalnie…',
    // Pigułka w nagłówku okna; pełne zdanie zostaje dla czytnika i w `title`.
    localOnly: 'plik zostaje na urządzeniu',
    localOnlyFull: 'Oryginalny plik audio lub wideo zostaje na tym urządzeniu. Wysyłamy tylko wybrany fragment dźwięku.',
    start: 'Początek',
    end: 'Koniec',
    length: 'Długość',
    play: 'Odtwórz od początku',
    pause: 'Pauza',
    keyboard: 'Spacja: pauza. Kolejne naciśnięcie: od początku fragmentu.',
    playEnding: 'Odsłuchaj końcówkę',
    pauseEnding: 'Pauza końcówki',
    fullMode: 'Cały fragment',
    endingMode: 'Końcówka w pętli',
    readyToPlay: 'Gotowe do odsłuchu',
    fades: 'Wyciszenie fragmentu',
    enableFades: 'Włącz łagodne wejście i wyjście',
    fadeIn: 'Łagodne wejście',
    fadeOut: 'Łagodne wyjście',
    fadeHelp: '0-{max} s na każdą stronę',
    playbackError: 'Nie udało się odtworzyć fragmentu. Spróbuj ponownie.',
    cancel: 'Anuluj',
    confirm: 'Wgraj ten fragment',
    // Okno pośrednie przy kilku plikach: nic jeszcze nie pobiera, więc nie ma kosztu.
    next: 'Dalej',
    decodeError: 'Nie udało się odczytać dźwięku. Plik może nie mieć ścieżki audio albo jej format nie jest obsługiwany. Wybierz inny plik.',
    tooLarge: 'Plik za duży · limit {max} MB',
  },
  wave: {
    computing: 'Liczę falę',
    fromFile: 'z pliku audio',
  },
  empty: {
    title: 'Wgraj pierwszy utwór',
  },
  toolbar: {
    upload: 'Wgraj utwór',
  },
  // Błąd wczytania listy (artboard 32/02e); prefiks kodu = ostatni człon trasy.
  error: {
    title: 'Nie udało się wczytać utworów.',
  },
  // SZEŚĆ SŁÓW STANU (reguła 45, tabela M2). Stan mówi o TEKŚCIE: artysta ocenia
  // utwór po tym, czy napisy będą dobre. Procesy techniczne w tle (rytm, fala,
  // przeliczenia) nie mają własnego stanu ani słowa — dopóki się liczą, utwór jest
  // „analizuję”; gdy tło zawiedzie trwale, utwór jest „błąd analizy”.
  // Ten sam słownik obowiązuje wszędzie, gdzie widać utwór (Muzyka, okno „Utwory”
  // Generatora, Pierwsze kroki, nagłówek „Tekst utworu”) — `lib/trackState.ts`.
  state: {
    analyzing: 'analizuję',
    noText: 'brak tekstu',
    auto: 'tekst automatyczny',
    approved: 'tekst zatwierdzony',
    analysisError: 'błąd analizy',
    fileError: 'błąd pliku',
  },
  actions: {
    // „Ponów” samo: wiersz nieudanego wgrywania (`R5-06`). Koszt dokleja etykieta płatna.
    retry: 'Ponów',
    // JEDNA droga naprawy analizy — tekstu i tła naraz (reguła 45).
    retryText: 'Ponów analizę tekstu',
    uploadOther: 'Wgraj inną wersję',
    use: 'Użyj',
    deleteFailed: 'Nie udało się usunąć utworu.',
  },
  // Menu wiersza / arkusz wiersza (`R5-07`, `R5-07b`): pozycja niszcząca po separatorze.
  menu: {
    more: 'Więcej akcji: {name}',
    editText: 'Edytuj tekst',
    remove: 'Usuń',
    delete: 'Usuń utwór',
  },
  // Wiersze tabeli liczb w oknach płatnych (reguła 46).
  cost: {
    cost: 'Koszt',
    have: 'Masz',
    left: 'Zostanie',
    missing: 'Brakuje',
  },
  // Saldo poniżej kosztu (`R5-09a`, `R5-09b`): trzy liczby i JEDNA droga.
  short: {
    title: 'Za mało tokenów',
    topUp: 'Doładuj tokeny',
  },
  // Okno ponowienia analizy (`R5-08`, `R5-08b`). Skutek uboczny stoi w tej samej
  // tabeli co liczby, jako DANA, nie jako zdanie.
  retryText: {
    title: 'Ponowić analizę tekstu?',
    approvedRow: 'Zatwierdzony tekst',
    approvedValue: 'zostanie zastąpiony',
  },
  // Okno błędu analizy (`R5-12`) i dana zwrotu w arkuszu wiersza (`R5-07b`).
  failure: {
    title: 'Błąd analizy',
    refundRow: 'Zwrócone tokeny',
    close: 'Zamknij',
  },
  // Wyjście ze strony w trakcie wgrywania (artboard 32/04c).
  leave: {
    title: 'Przerwać?',
    body: 'Wgrywanie jeszcze trwa. Jeśli wyjdziesz, zacznie się od nowa.',
    stay: 'Zostań',
    leave: 'Wyjdź',
  },
  // Toasty (`R5-15`): jeden fakt po akcji, z liczbą tam, gdzie coś pobrano albo wróciło.
  // Wgranie utworu jest darmowe, więc jego toast jest samym faktem; wersje bez `{cost}`
  // przy analizie stoją, gdy serwer nie podał stawki — front nie zgaduje ceny.
  toast: {
    uploaded: 'Utwór wgrany.',
    uploadedMany: 'Wgrano {n} utworów.',
    uploadedMany_one: 'Wgrano {n} utwór.',
    uploadedMany_few: 'Wgrano {n} utwory.',
    uploadedMany_many: 'Wgrano {n} utworów.',
    deleted: 'Utwór usunięty.',
    aborted: 'Wgrywanie przerwane.',
    retried: 'Analiza ponowiona.',
    retriedCost: 'Analiza ponowiona',
    analysisFailed: 'Błąd analizy.',
    analysisFailedRefund: 'Błąd analizy',
    deleteFailed: 'Nie udało się usunąć utworu.',
  },
  // Okno usunięcia (artboard 32/04a): jedno zdanie, wiersze strat, „Usuń utwór” ostrzega.
  delete: {
    ask: 'Usunąć „{name}”?',
    body: 'Plik i tekst znikną. Wyrenderowane serie zostają.',
    rowFile: 'Plik',
    rowText: 'Tekst',
    words: '{n} słów',
    words_one: '{n} słowo',
    words_few: '{n} słowa',
    words_many: '{n} słów',
    noText: 'bez tekstu',
    cancel: 'Anuluj',
  },
  // 46-A (paczka PS): arkusz „Obejrzenia utworu” (klatka 02b). Element w wierszu korzysta
  // z kluczy `appStats.tracks.*` — jedno źródło tekstu pierścienia.
  stats: {
    title: 'Obejrzenia utworu',
    thresholds: 'Progi',
    posts: 'Posty · {count}',
    // Nazwa przycisku elementu dla czytnika ekranu.
    open: 'Obejrzenia utworu {track}',
  },
}
